<template>
  <div class="all-wrapper menu-side with-pattern" id="app-login">
    <div class="auth-box-w" style="max-width: 100% !important;"
      :style="buzon_anonimo ? 'background-color: #e8e8e8;' : ''">
      <div class="logo-w" style="padding: 1% 20%;">
        <a href="/">
          <img alt src="/logo.png" style="width: 10%;" />
        </a>
      </div>
      <div class="onboarding-modal modal fade animated" id="previewBuzonSugerencia" role="dialog" tabindex="-1"
        aria-hidden="true" style="display: none;">
        <div class="modal-dialog modal-centered" role="document">
          <div class="modal-content text-center">
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span class="close-label" ref="cerrarModal">Cerrar</span><span class="os-icon os-icon-close"></span>
            </button>
            <div class="onboarding-content with-gradient">
              <h4 class="onboarding-title">
                Bienvenido(a) al buzón de sugerencias,
              </h4>
              <div class="onboarding-text" style="text-align: left;">
                Esta sección fue diseñada para que puedas dejar tus sugerencias o quejas;
                recuerda que puedes dejar tu registro con tus datos o bien, comentar de manera anónima.
                <br />
                <br />
                Elige la opción con la que te sientas más cómodo.
                <br />
                <br />
                <div class="element-box-content row">
                  <button class="mr-2 mb-2 btn btn-secondary btn-lg" type="button" @click="seranonimo(true)"
                    style="font-size: 16px;">
                    Anónimo&nbsp;<i class="fas fa-user-secret"></i>
                  </button>
                  <button class="mr-2 mb-2 btn btn-primary btn-lg" type="button" @click="seranonimo(false)"
                    style="font-size: 16px;">
                    Comentar como {{ current.user }} <i class="fas fa-child"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <h4 class="auth-header" style="display: inline-block;">Buzón de Sugerencias y Quejas</h4>
      <div style="display: inline-block; margin-left: 760px;">
        <button class="mr-2 mb-2 btn btn-secondary" type="button" @click="seranonimo(true)" v-if="!buzon_anonimo">
          <i class="fas fa-undo"></i> Comentar como Anónimo
        </button>
        <button class="mr-2 mb-2 btn btn-primary" type="button" @click="seranonimo(false)" v-if="buzon_anonimo">
          <i class="fas fa-undo"></i> Comentar con mis Datos
        </button>
      </div>
      <form method="post" @submit="login">
        <div class="row">
          <div class="col-md-12">
          </div>
          <div class="col-md-6">
            <div class="form-group" v-if="!buzon_anonimo">
              <label>Nombre</label>
              <input v-model="current.nombre" autofocus class="form-control" placeholder="Nombre" type="text" />
              <small v-if="current.errors && current.errors.nombre" class="form-text text-danger">{{
                current.errors.nombre[0] }}</small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group" v-if="!buzon_anonimo">
              <label>Puesto</label>
              <input v-model="current.puesto" class="form-control" placeholder="Puesto" type="text"
                :disabled="current.id" />
              <small v-if="current.errors && current.errors.puesto" class="form-text text-danger">{{
                current.errors.puesto[0] }}</small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group" v-if="!buzon_anonimo">
              <label>Correo Electrónico</label>
              <input v-model="current.email" class="form-control" placeholder="Correo Electrónico" type="text"
                :disabled="current.id" />
              <small v-if="current.errors && current.errors.email" class="form-text text-danger">{{
                current.errors.email[0] }}</small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group" v-if="!buzon_anonimo">
              <label>Teléfono</label>
              <input v-model="current.telefono" class="form-control" placeholder="Teléfono" type="text"
                :disabled="current.id" />
              <small v-if="current.errors && current.errors.telefono" class="form-text text-danger">{{
                current.errors.telefono[0] }}</small>
            </div>
          </div>
          <div class="col-12">
            <label style="color: #a8a8a8;">Tipo de Mensaje</label>
            <ul class="nav nav-pills mt-2 mb-3">
              <li class="nav-item">
                <a class="nav-link" :class="{
                  active: current.tipo == 'C',
                }" @click="current.tipo = 'C'" data-toggle="tab" href="#">COMENTARIO</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="{
                  'active btn-secondary': current.tipo == 'S',
                }" @click="current.tipo = 'S'" data-toggle="tab" href="#">SUGERENCIA</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="{ 'active btn-danger': current.tipo == 'Q' }" @click="current.tipo = 'Q'"
                  data-toggle="tab" href="#">QUEJA</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="form-group">
          <label>Comentario</label>
          <textarea class="form-control" rows="10" v-model="current.comentario" placeholder="---" required type="text"
            :disabled="current.id"></textarea>
          <small v-if="current.errors && current.errors.comentario" class="form-text text-danger">{{
            current.errors.comentario[0] }}</small>
        </div>

        <div class="buttons-w" style="float: right;">
          <button type="submit" class="btn btn-info btn-md">Enviar <i class="fas fa-paper-plane"></i></button>
        </div>
        <br>
      </form>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  data() {
    return {
      buzon_anonimo: false,
      current: {
        nombre: "",
        nombre: "",
        puesto: "",
        comentario: "",
        tipo: "C",
        area: null,
        errors: {
          nombre: [],
          nombre: [],
          puesto: [],
          comentario: [],
          tipo: [],
          area: [],
        },
        user: localStorage.getItem("name"),
      },
    };
  },
  components: {},
  beforeMount() {
    this.$store.commit("SET_LAYOUT", "clean-layout");
  },
  created() {
    setTimeout(function () {
      $("#previewBuzonSugerencia").modal("show");
    }, 500);
  },
  methods: {
    seranonimo(anonimo_si_no) {
      let self = this;
      self.buzon_anonimo = anonimo_si_no;
      if (anonimo_si_no) {
        self.current.nombre = null;
        self.current.nombre = null;
        self.current.puesto = null;
      }
      else {
        self.current.nombre = self.current.user;
      }
      self.$refs.cerrarModal.click();
    },
    async login(e) {
      e.preventDefault();
      let self = this;

      await DynamicService.save("rrhh", "buzon-sugerencias", self.current)
        .then((res) => {
          let id = res.data.id;

          Notifications.alert.success(
            "Gracias por tus comentarios.",
            "Recuerda que tu " +
            res.data.tipo_str +
            " es totalmente anónimo, le daremos seguimiento a tu " +
            res.data.tipo_str +
            " cuanto antes. /n Id: " +
            id
          );
          self.current = {
            nombre: "",
            numero: null,
            nombre: "",
            puesto: "",
            comentario: "",
            tipo: "C",
            estado: "A",
            area: null,
            errors: {
              nombre: [],
              numero: [],
              nombre: [],
              puesto: [],
              comentario: [],
              tipo: [],
              estado: [],
              area: [],
            },
          };
          $("#previewBuzonSugerencia").modal("show");
        })
        .catch((err) => {
          console.log(err);
          Object.assign(self.current.errors, err.response.data);
        });
    },
  },
};
</script>
